// extracted by mini-css-extract-plugin
export default {"SquareButton":"SquareButton_SquareButton__w1KxM"};